<div id="main-content">
  <div class="container-fluid">
    <app-breadcrumb [dataInput]="breadCrumb"></app-breadcrumb>


    <div class="row clearfix">
      <div class="col-lg-12">
        <div class="card">
          <div class="header">
            <h2>Transaction Reports</h2>
            <div class="d-flex align-items-center justify-content-between flex-wrap mt-5" style="gap: 3px;">
              <div class="align-self-baseline">Filter By:</div>
              <form class="d-flex align-items-center flex-wrap" style="gap: 3px;" [formGroup]="filterForm" (ngSubmit)="onFilterForm()">
                <div *ngIf="checkPrivilege(['super_agent'])">
                  <label for="agent">Agent Name</label>
                  <select id="agent" class="form-control" formControlName="agent_id">
                    <option *ngFor="let a of agents" [value]="a.value" [id]="a.id"  >{{a.name}}</option>
                  </select>
                </div>
                <div>
                  <label for="fDate">Start Date</label>
                  <input formControlName="from" id="fDate" type="date" class="form-control">
                </div>
                <div>
                  <label for="eDate">End Date</label>
                  <input formControlName="to" id="eDate" type="date" class="form-control">
                </div>
                <div>
                  <label for="category">Category</label>
                  <select id="category" class="form-control" formControlName="category">
                    <option *ngFor="let c of categories" [value]="c.name" [id]="c.id"  >{{c.name}}</option>
                  </select>
                </div>
                <div>
                  <label for="zone">Zone</label>
                  <select id="zone" class="form-control" formControlName="zone_id">
                    <option *ngFor="let z of zones" [value]="z.value" [id]="z.id"  >{{z.name}}</option>
                  </select>
                </div>
                <button [disabled]="onFormValidate() || loadingData" class="btn btn-primary align-self-end mt-2" type="submit">Filter</button>
                <button (click)="onFormReset()" class="btn btn-danger align-self-end mt-2">Reset</button>
              </form>
            </div>
          </div>
          <div class="body">
            <div class="text-center mt-1 mb-3" *ngIf="loadingData"><span class="fa fa-spin fa-spinner fa-2x"></span>&nbsp; Loading, Please wait...</div>
            <div class="table-responsive" *ngIf="showData">
              <table id="revenue-reports" class="table table-bordered table-hover table-striped dataTable" cellspacing="0" width="100%">
                <thead>
                <tr >
                  <th class="no-sort" width="5%"></th>
                  <th>#</th>
                  <!--<th>Action</th>-->
                  <th>Amount</th>

                  <th>Agent</th>
                  <th>Ticket Number</th>
                  <th>Date</th>

                  <th>Category</th>
                  <th>Zone</th>

                </tr>
                </thead>
                <tfoot>
                <tr >
                  <th class="no-sort"></th>
                  <th>#</th>
                  <!--<th>Action</th>-->
                  <th>Amount</th>

                  <th>Agent</th>
                  <th>Ticket Number</th>
                  <th>Date</th>

                  <th>Category</th>
                  <th>zone</th>

                </tr>
                </tfoot>
                <tbody>
                <tr *ngFor="let trans of transactions;let i = index;">

                  <td class="details-control" [id]="'td-' + i" ></td>
                  <td>{{ i + 1 }}</td>
                  <td>{{ trans?.amount | currency: '&#8358;' }}</td>
                  <td>{{ trans?.agent}}</td>
                  <td>{{ trans?.ticket_number }}</td>
                  <td>{{ trans?.date_time | date: 'MMM d, y, h:mm a' }}</td>
                  <td>{{ trans?.category  | titlecase}}</td>
                  <th>{{ trans?.zone  | titlecase}}</th>
                </tr>
                </tbody>

              </table>
            </div>
          </div>
        </div>
      </div>

    </div>



  </div>
</div>
